<template>
    <div id="page-wifi-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-center">
                <div class="flex-grow">
                    <vs-button
                        v-if="isPermissionAdd()"
                        @click="addWifi"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-wifi">
                        {{$t('wifi.addWifi')}}
                    </vs-button>
                </div>

                <!-- ITEMS PER PAGE -->
<!--                <Pagination-->
<!--                    :itemList="wifiList"-->
<!--                    :currentPage="currentPage"-->
<!--                    :paginationPageSize="paginationPageSize"-->
<!--                    :gridApi="gridApi"-->
<!--                />-->


                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                          v-model="searchQuery"
                          @input="updateSearchQuery" :placeholder="$t('button.search')"/>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="wifiList"
                         :animateRows="true"
                         :localeText=" {noRowsToShow: this.$t('menuCamera.noRowsToShow')}"
                         paginationPageSize="10"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000">
            </ag-grid-vue>

            <div class="vx-row mt-8" v-if="totalElements > 0">
                <div style="min-width:200px" class="vx-col md:w-1/2 w-full">
                    <span class="content-page font-bold">Hiển thị: </span>
                    <span class="text-page">
                        {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{ totalElements }}
                    </span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination
                        :total="totalPages"
                        v-model="currentPage"
                        @change="loadPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue"
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import CellRendererStatus from "../../admin-pages/organization/cell-renderer/CellRendererStatus";
import { isAPI, isRouter } from "../../../store/permission";
import { constAPI, constRouter } from "../../../store/constant";

export default {
    components: {
        AgGridVue,

        // Cell Renderer
        CellRendererActions,
        Pagination,
        CellRendererStatus
    },
    data() {
        return {
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 100
                },
                {
                    headerName: 'Wifi BSSID',
                    field: 'organizationBranchName',
                    width: 200,
                },
                {
                    headerName: this.$t('wifi.addWifi'),
                    field: 'wifiName',
                    width: 200
                },
                {
                    headerName: this.$t('wifi.status'),
                    field: 'status',
                    width: 200,
                    cellRenderer: 'CellRendererStatus'
                },
                {
                    headerName: this.$t('wifi.actions'),
                    field: 'actions',
                    width: 100,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                },
            ],
            wifiList: [],
            branchId: null,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
        }
    },
    created() {
        this.initScreen();
    },
    watch: {
        '$store.state.deleteWifiStatus'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_WIFI_STATUS', false);
            }
        },
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.wifi_add)
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        addWifi() {
            let url = '/user/add-wifi';
            if (this.branchId)
                url = `${url}?branch_id=${this.branchId}`;

            this.$router.push(url).catch(() => {
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
        initScreen() {
            this.$vs.loading();
            this.branchId = this.$route.query.branch_id;

            let url = '/wifi/find-by-organization',
                branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');

            this.$vs.loading();
            this.$crm.post(url).then((response) => {
                this.$vs.loading.close();
                response.data.forEach((item) => {
                    let branchInfo = branchList.find(x => x.id === item.organizationBranchId);
                    if (branchInfo)
                        item.organizationBranchName = branchInfo.organizationBranchName;
                });
                this.wifiList = response.data.map(item => {
                    item.displayStatus = item.status == 0 ? this.$t('wifi.notWork') : this.$t('wifi.work');
                    return item;
                });
                this.countElementPage = this.currentPage * 10;
                this.totalElements = this.wifiList.length;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
